// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fr-9";
export var fulfillmentFormRail = "_fr-8";
export var headerTitleRow = "_fr-b";
export var orderDetailsWrapper = "_fr-6";
export var paymentInformationGrid = "_fr-g";
export var paymentSummaryColumn = "_fr-h";
export var shipmentContainer = "_fr-a";
export var shipmentDetailsMainPane = "_fr-7";
export var shipmentNavigationCard = "_fr-4";
export var shipmentNavigationRail = "_fr-2";
export var shipmentNavigationRailHeader = "_fr-3";
export var shipmentSummaryFact = "_fr-d";
export var shipmentSummaryGrid = "_fr-c";
export var shipmentSummaryMetadataRow = "_fr-e";
export var shipmentSummaryTags = "_fr-f";
export var shipmentWorkspace = "_fr-0";
export var shipmentWorkspaceContent = "_fr-5";
export var shipmentWorkspaceHeader = "_fr-1";